export default __webpack_public_path__ + "static/media/person-mountain-biking_dark-skin-tone_1f6b5-1f3ff_1f3ff.2eb706e9.png";